import { CloseIcon, IconButton } from '@thefarmersfront/kitchen-mobile';

import { TypeContract } from '~/types';

import MenuDrawerBanner from './MenuDrawerBanner';

import styles from './MenuDrawerHeader.module.scss';

const MenuDrawerHeader = ({ contractType, closeDrawer }: { contractType?: TypeContract; closeDrawer: () => void }) => {
  return (
    <>
      <div className={styles['drawer-header-container']}>
        <IconButton color="secondary" onClick={closeDrawer}>
          <CloseIcon color="dark" />
        </IconButton>
      </div>
      <MenuDrawerBanner contractType={contractType} closeDrawer={closeDrawer} />
    </>
  );
};

export default MenuDrawerHeader;
